<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('der1')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('der2')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <!-- <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item :label="$t('bookName')">
                                <el-select size="small" v-model="searchform.accountId" style="width:180px;" :placeholder="$t('pleaseZhangqi')"  >
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option v-for="(item,index) in accountlist" :label="item.bookName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>-->
                    <div class="searchright">
                        <el-button size="small" type="primary" @click="openadd">+{{$t('der3')}}</el-button>
                    </div> 
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="percentage" :label="$t('der5')"></el-table-column>
                        <el-table-column prop="singular" :label="$t('der6')"></el-table-column>
                        <el-table-column prop="accountName" :label="$t('bookName')"></el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-button size="small" @click="openedit(scope.row)" type="primary" icon="el-icon-edit"
                                    circle plain style="margin-right:5px;"></el-button>
                                <el-popconfirm :title="$t('isDel')" @confirm="deleteproduct(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-delete-solid" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <pop-up :title="status == 1 ? $t('der3') : $t('der4')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item :label="$t('der5')" prop="percentage" style="width:600px;">
                        <el-input-number v-model="form.percentage" :min="0" :max="100"/>
                    </el-form-item>
                    <el-form-item :label="$t('der6')" prop="singular" style="width:600px;">
                        <el-input-number v-model="form.singular" :min="0"/>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    percentage: null,
                    singular: null,
                    accountId: null,
                    accountName: null
                },
                searchform: {
                    blurry: "",
                },
                loading: false,
                showadd: false,
                list: [],
                accountlist: [],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.searchform.accountId = this.$route.query.accountId
            this.getList()
            this.getaccount()
        },
        methods: {
            openadd() {
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    percentage: null,
                    singular: null,
                    accountName: null,
                    accountId: this.$route.query.accountId
                }
            },
            openedit(row) {
                this.status = 2
                this.form.id = row.id
                this.form.percentage = row.percentage
                this.form.singular = row.singular
                this.form.accountId = row.accountId
                this.showadd = true
            },
            getaccount() {
                _api.get(apiurl.accountBook, {
                }).then(res => {
                    this.accountlist = res.data
                })
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            deleteproduct(row) {
                _api.delete(apiurl.derate, row.id).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('delSuccess'),
                        type: 'success'
                    });
                    this.getList()
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            getconfirm() {
                if (this.status == 1) { //如果是添加
                    _api.post(apiurl.derate, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('addSuccess')
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            percentage: null,
                            singular: null,
                            accountId: this.accountId
                        }

                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else { //如果是编辑
                    _api.put(apiurl.derate, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('editSuccess')
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            percentage: null,
                            singular: null,
                            accountId: this.accountId
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                  
            },
            getList() {
                this.loading = true
                _api.get(apiurl.derate, {
                    accountId: this.searchform.accountId
                }).then(res => {
                    this.loading = false
                    this.accountId = this.accountId
                    this.list = res.data
                })
            },
            onSubmit() {
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>